import { render, staticRenderFns } from "./questions-edit.vue?vue&type=template&id=77d5a288&scoped=true&"
import script from "./questions-edit.vue?vue&type=script&lang=js&"
export * from "./questions-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d5a288",
  null
  
)

export default component.exports